import React, { useState, useEffect } from "react";
import * as Sentry from "@sentry/react";
import css from "../../style/howMovEzWorks.module.css";
import { getFAQs } from "../../store/actions/CommonActions";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  CircularProgress,
} from "@material-ui/core";
import { BsChevronDown } from "react-icons/bs";

const FAQAccordion = ({ question, answer }) => {
  return (
    <div className={css?.s8FAQM}>
      <Accordion className={css?.s8FAQAcc}>
        <AccordionSummary
          expandIcon={<BsChevronDown />}
          collapse
          aria-controls="panel1a-content"
          id="panel1a-header"
          className={css?.s8FAQSummary}
        >
          <div className={css.s8AccordionQuestion}>{question}</div>
        </AccordionSummary>
        <AccordionDetails className={css.s8AccordionAnswer}>
          {answer}
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

const Section8 = () => {
  const [FAQs, setFAQs] = useState([]);
  const [FAQsLoading, setFAQsLoading] = useState(true);
  useEffect(() => {
    try {
      getFAQs(setFAQs, setFAQsLoading);
    } catch (error) {
      Sentry.captureException(error);
    }
  }, []);

  return (
    <div className={css?.s8M}>
      <div className={css?.s8Heading}>Frequently asked questions</div>
      {FAQsLoading ? (
        <div style={{ textAlign: "center" }}>
          <CircularProgress />
        </div>
      ) : (
        <div className={css?.s8FAQs}>
          {FAQs?.map((FAQ) => (
            <FAQAccordion {...FAQ} />
          ))}
        </div>
      )}
    </div>
  );
};

export default Section8;
